import React from 'react'
import {useNavigate,Link} from "react-router-dom";


const NavBar = (props) => {

    const navigate = useNavigate();

    const renderBackBtn = ()=> {
        let {
            back,
            inverted,
        } = props;

        let btnStyles = {
            ...styles.backBtn,
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            padding: '0 16px 10px 0',
            // padding: 0,
            color: inverted ? '#323C47' : '#F5F6F8',
            maxWidth: '100%'
        };

        if (TB.isObject(back)
            && (TB.isString(back.path) || TB.isObject(back.path))) {
            return (
                <Link to={back.path}
                      style={btnStyles}>
                    <i className="fa fa-arrow-left mr-2"/>
                    {back.title || 'Back'}
                </Link>
            );
        }


        if ((TB.isObject(back) && !back.path) || (TB.isBoolean(back) && back)) {
            return (
                <button type="button"
                        className="btn btn-link"
                        style={btnStyles}
                        onClick={() => navigate(-1)}>
                    <i className="fa fa-arrow-left mr-2"/>
                    {back.title || 'Back'}
                </button>
            );
        }


        return <div/>;
    }

    const showBackBtn = ()=> {
        let {
            back,
        } = props;

        return (TB.isObject(back) && TB.isString(back.path))
            || (TB.isBoolean(back) && back);
    }

    let {
        title,
        stats,
        button,
        inverted,
    } = props;
    // <div className={"nav-container"} style={inverted ? {backgroundColor: 'transparent'} : {}}>

        return (
            <div className="flex justify-between py-3 px-3 md:px-4 md:py-6"
                 style={{...styles.container, background: inverted ? 'transparent' : 'black'}}>

            {renderBackBtn()}

                {(title || stats) && (
                    <div style={{
                        ...styles.titleContainer,
                        justifyContent: showBackBtn() ? 'center' : 'flex-start',
                    }}>
                        {title && (
                            <h2 className="inline mr-3 mb-0 text-white"
                                style={{fontWeight: 300, fontSize: '1.5rem', marginBottom: 0, color: 'white'}}>
                                {TB.tryTrans(title)}
                            </h2>
                        )}

                        {TB.isArray(stats) && stats.map((stat, i) => (
                            <p key={`navBarStat${i}`}
                               className="ml-3 hidden md:inline mb-0 text-white"
                               style={{fontSize: '12px'}}>
                                {TB.tryTrans(stat.title)}: <span
                                style={{fontSize: '14px', fontWeight: 500}}>{stat.value}</span>
                            </p>
                        ))}

                </div>

            )}
            {props.children}

            <div style={{flex: 1, textAlign: 'right', display: 'flex', flexDirection: 'column'}}>

                {TB.isElement(button) ? button : (
                    TB.isObject(button) && TB.isString(button.path) && (
                        <Link to={button.path}

                              className="btn btn-primary px-4 py-2"
                              style={{alignSelf: 'flex-end', width: 'unset'}}>
                            {TB.isString(button.icon) && <i className={`fa fa-${button.icon} mr-2`}/>}
                            <span className="hidden md:inline">{TB.tryTrans(button.title)}</span>
                        </Link>
                    )
                )}
            </div>

        </div>
    );
}

export default NavBar

const styles = {
    container: {
        // background: '#323C47',
        alignItems: 'center',
    },
    backBtn: {
        // color: '#F5F6F8',
        alignSelf: 'center',
        flex: 1,
    },
    titleContainer: {
        color: 'white',
        margin: '0 auto',
        // flex: 1,
        maxWidth: '100%',
        display: 'flex',
        alignItems: 'center',
    },
};